@if (control.hasError('required') || control.hasError('pattern') || control.hasError('max') || control.hasError('min')) {
  <div class="d-inline-block validation-message mb-2 ml-1">
    @if (control.hasError('required')) {
      {{ 'FORM_VALIDATION.IS_REQUIRED' | translate }}
    }
    @if (control.hasError('pattern')) {
      @if (inputData.propertyName === 'vehicleLicenseNumber') {
        <span>
          @if (!inputData.propertyConfig.MOTORCYCLE && !inputData.propertyConfig.BOAT && !inputData.propertyConfig.VETERAN_CAR && !inputData.propertyConfig.SNOWMOBILE && !inputData.propertyConfig.MOPED  && !inputData.propertyConfig.TRAILER && !inputData.propertyConfig.TRAILER_HOME && !inputData.propertyConfig.TRACTOR) {
            <span>
              {{ 'FORM_VALIDATION.VEHICLE_LICENCE_NUMBER_INVALID' | translate }}
            </span>
          }
          @if (inputData.propertyConfig.MOTORCYCLE) {
            <span>
              {{ 'FORM_VALIDATION.VEHICLE_LICENCE_NUMBER_INVALID_MOTORCYCLE' | translate }}
            </span>
          }
          @if (inputData.propertyConfig.MOPED) {
            <span>
              {{ 'FORM_VALIDATION.VEHICLE_LICENCE_NUMBER_INVALID_MOPED' | translate }}
            </span>
          }
          @if (inputData.propertyConfig.SNOWMOBILE) {
            <span>
              {{ 'FORM_VALIDATION.VEHICLE_LICENCE_NUMBER_INVALID_SNOWMOBILE' | translate }}
            </span>
          }
          @if (inputData.propertyConfig.BOAT) {
            <span>
              {{ 'FORM_VALIDATION.VEHICLE_LICENCE_NUMBER_INVALID_BOAT' | translate }}
            </span>
          }
          @if (inputData.propertyConfig.TRAILER) {
            <span>
              {{ 'FORM_VALIDATION.VEHICLE_LICENCE_NUMBER_INVALID_TRAILER' | translate }}
            </span>
          }
          @if (inputData.propertyConfig.VETERAN_CAR) {
            <span>
              {{ 'FORM_VALIDATION.VEHICLE_LICENCE_NUMBER_INVALID_VETERAN_CAR' | translate }}
            </span>
          }
          @if (inputData.propertyConfig.TRAILER_HOME) {
            <span>
              {{ 'FORM_VALIDATION.VEHICLE_LICENCE_NUMBER_INVALID_TRAILER_HOME' | translate }}
            </span>
          }
          @if (inputData.propertyConfig.TRACTOR) {
            <span>
              {{ 'FORM_VALIDATION.VEHICLE_LICENCE_NUMBER_INVALID_TRACTOR' | translate }}
            </span>
          }
        </span>
      }
      @if (inputData.propertyName === 'clientSsn') {
        <span class="validation-message--large">
          {{ 'FORM_VALIDATION.SSN_INVALID_LARGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'objectZipCode' || inputData.propertyName === 'zipCode') {
        <span>
          {{ 'FORM_VALIDATION.ZIP_CODE_INVALID' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'boatLength') {
        <span>
          {{ 'FORM_VALIDATION.INTEGER_NUMBER' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'calculatedClientAge') {
        <span>
          {{ 'FORM_VALIDATION.INTEGER_NUMBER' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'mobileHomeMarketValue' && !inputData.propertyConfig.SUM_INSURED_THOUSANDS_ONLY && !inputData.propertyConfig.MOBILE_HOME_MARKET_VALUE_RANGE_TO_1500000) {
        <span>
          {{ 'FORM_VALIDATION.MOBILE_HOME_MARKET_VALUE_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'mobileHomeMarketValue' && inputData.propertyConfig.MOBILE_HOME_MARKET_VALUE_RANGE_TO_1500000) {
        <span>
          {{ 'FORM_VALIDATION.MOBILE_HOME_MARKET_VALUE_RANGE_TO_1500000' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'trailerMarketValue' && inputData.propertyConfig.TRAILER_MARKET_VALUE_RANGE_TO_1500000) {
        <span>
          {{ 'FORM_VALIDATION.TRAILER_MARKET_VALUE_RANGE_TO_1500000' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'productSumInsured' && inputData.propertyConfig.TRACTOR_SUM_INSURED_RANGE) {
        <span>
          {{ 'FORM_VALIDATION.TRACTOR_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'productSumInsured' && inputData.propertyConfig.SNOWMOBILE_SUM_INSURED_RANGE) {
        <span>
          {{ 'FORM_VALIDATION.SNOWMOBILE_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'animalSIDeath' && inputData.propertyConfig.ANIMAL_DEATH_SUM_INSURED_RANGE) {
        <span>
          {{ 'FORM_VALIDATION.ANIMAL_DEATH_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'animalSIDeath' && inputData.propertyConfig.ANIMAL_DEATH_SUM_INSURED_RANGE_FROM_5000) {
        <span>
          {{ 'FORM_VALIDATION.ANIMAL_ILLNESS_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'animalSIIllness' && inputData.propertyConfig.ANIMAL_ILLNESS_SUM_INSURED_RANGE) {
        <span>
          {{ 'FORM_VALIDATION.ANIMAL_ILLNESS_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'animalSIIllness' && inputData.propertyConfig.ANIMAL_ILLNESS_SUM_INSURED_RANGE_FROM_1) {
        <span>
          {{ 'FORM_VALIDATION.ANIMAL_ILLNESS_SUM_INSURED_RANGE_FROM_1' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'productSumInsured' && inputData.propertyConfig.HOUSE_CONTENT_SUM_INSURED_MIN_300000) {
        <span>
          {{ 'FORM_VALIDATION.HOUSE_CONTENT_SUM_INSURED_MIN_300000' | translate }}
        </span>
      }
      @if ((inputData.propertyName === 'productSumInsured' || inputData.propertyName === 'mobileHomeMarketValue') && inputData.propertyConfig.SUM_INSURED_THOUSANDS_ONLY) {
        <span>
          {{ 'FORM_VALIDATION.SUM_INSURED_THOUSANDS_ONLY' | translate }}
        </span>
      }
    }
    @if (control.hasError('max')) {
      @if (inputData.propertyName === 'contentsSumInsured' || (inputData.propertyName === 'productSumInsured' && inputData.propertyConfig.key === 'EXTENDED_SUM_AMOUNT')) {
        <span>
          {{ 'FORM_VALIDATION.EXTENDED_SUM_AMOUNT_MAX_400000' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'mobileHomeMarketValue' && !inputData.propertyConfig.MOBILE_HOME_MARKET_VALUE_RANGE_TO_1500000) {
        <span>
          {{ 'FORM_VALIDATION.MOBILE_HOME_MARKET_VALUE_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'mobileHomeMarketValue' && inputData.propertyConfig.MOBILE_HOME_MARKET_VALUE_RANGE_TO_1500000) {
        <span>
          {{ 'FORM_VALIDATION.MOBILE_HOME_MARKET_VALUE_RANGE_TO_1500000' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'trailerMarketValue' && inputData.propertyConfig.TRAILER_MARKET_VALUE_RANGE_TO_1500000) {
        <span>
          {{ 'FORM_VALIDATION.TRAILER_MARKET_VALUE_RANGE_TO_1500000' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'productSumInsured' && inputData.propertyConfig.TRACTOR_SUM_INSURED_RANGE) {
        <span>
          {{ 'FORM_VALIDATION.TRACTOR_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'productSumInsured' && inputData.propertyConfig.SNOWMOBILE_SUM_INSURED_RANGE) {
        <span>
          {{ 'FORM_VALIDATION.SNOWMOBILE_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'animalSIDeath' && inputData.propertyConfig.ANIMAL_DEATH_SUM_INSURED_RANGE) {
        <span>
          {{ 'FORM_VALIDATION.ANIMAL_DEATH_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'animalSIDeath' && inputData.propertyConfig.ANIMAL_DEATH_SUM_INSURED_RANGE_FROM_5000) {
        <span>
          {{ 'FORM_VALIDATION.ANIMAL_ILLNESS_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'animalSIIllness' && inputData.propertyConfig.ANIMAL_ILLNESS_SUM_INSURED_RANGE) {
        <span>
          {{ 'FORM_VALIDATION.ANIMAL_ILLNESS_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'animalSIIllness' && inputData.propertyConfig.ANIMAL_ILLNESS_SUM_INSURED_RANGE_FROM_1) {
        <span>
          {{ 'FORM_VALIDATION.ANIMAL_ILLNESS_SUM_INSURED_RANGE_FROM_1' | translate }}
        </span>
      }
    }
    @if (control.hasError('min')) {
      @if (inputData.propertyName === 'contentsSumInsured' || (inputData.propertyName === 'productSumInsured' && inputData.propertyConfig.key === 'EXTENDED_SUM_AMOUNT')) {
        <span>
          {{ 'FORM_VALIDATION.EXTENDED_SUM_AMOUNT_MIN_0' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'mobileHomeMarketValue' && !inputData.propertyConfig.MOBILE_HOME_MARKET_VALUE_RANGE_TO_1500000) {
        <span>
          {{ 'FORM_VALIDATION.MOBILE_HOME_MARKET_VALUE_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'mobileHomeMarketValue' && inputData.propertyConfig.MOBILE_HOME_MARKET_VALUE_RANGE_TO_1500000) {
        <span>
          {{ 'FORM_VALIDATION.MOBILE_HOME_MARKET_VALUE_RANGE_TO_1500000' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'trailerMarketValue' && inputData.propertyConfig.TRAILER_MARKET_VALUE_RANGE_TO_1500000) {
        <span>
          {{ 'FORM_VALIDATION.TRAILER_MARKET_VALUE_RANGE_TO_1500000' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'productSumInsured' && inputData.propertyConfig.TRACTOR_SUM_INSURED_RANGE) {
        <span>
          {{ 'FORM_VALIDATION.TRACTOR_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'productSumInsured' && inputData.propertyConfig.SNOWMOBILE_SUM_INSURED_RANGE) {
        <span>
          {{ 'FORM_VALIDATION.SNOWMOBILE_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'animalSIDeath' && inputData.propertyConfig.ANIMAL_DEATH_SUM_INSURED_RANGE) {
        <span>
          {{ 'FORM_VALIDATION.ANIMAL_DEATH_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'animalSIDeath' && inputData.propertyConfig.ANIMAL_DEATH_SUM_INSURED_RANGE_FROM_5000) {
        <span>
          {{ 'FORM_VALIDATION.ANIMAL_ILLNESS_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'animalSIIllness' && inputData.propertyConfig.ANIMAL_ILLNESS_SUM_INSURED_RANGE) {
        <span>
          {{ 'FORM_VALIDATION.ANIMAL_ILLNESS_SUM_INSURED_RANGE' | translate }}
        </span>
      }
      @if (inputData.propertyName === 'animalSIIllness' && inputData.propertyConfig.ANIMAL_ILLNESS_SUM_INSURED_RANGE_FROM_1) {
        <span>
          {{ 'FORM_VALIDATION.ANIMAL_ILLNESS_SUM_INSURED_RANGE_FROM_1' | translate }}
        </span>
      }
    }
  </div>
}
